<template>
  <section
    class="section intro-text"
    v-editable="blok"
    ref="refRoot"
  >
    <div class="bg-black" />
    <div class="the-container">
      <div class="the-grid">
        <div class="the-col">
          <RenderRichText :document="blok.body" />
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
const props = defineProps({
  blok: {
    type: Object,
    required: true,
  },
})

const emits = defineEmits([])

const { $gsap, $ScrollTrigger } = useNuxtApp()

const { app, debug, browser } = useStores()

const refRoot = ref(null)

// useDotsTrigger({
//   trigger: refRoot,
//   to: { ambientStrength: 0, flowMapStrength: 0 },
// })
</script>

<style lang="scss" scoped>
@import "@/styles/shared.scss";

.intro-text {
  padding-block: 30rem 20rem;
}

.the-col {
  grid-column: 1 / span 6;
  @include type-body2;
}

@include mobile {
  .intro-text {
    padding-block: 7.2rem 14rem;
  }

  .the-col {
    grid-column: 1 / -1;
    @include type-body3;
  }
}
</style>
